<div class="app-selection container mt-5">
    <div class="text-center hero my-5">
        <img class="mb-3 app-logo" src="../../assets/logo.png" alt="Angular logo" />
        <h1 class="mb-4">LTC</h1>

        <p class="lead">
            The engineering tool suite from
            <a href="https://www.tinarmengineering.com/">Tin Arm</a>
        </p>
    </div>

    @if ((auth.isAuthenticated$ | async) === false) {
    <div class="alert alert-info" role="status">Log in to choose an application.</div>
    }

    <div class="apps-grid">
        <article class="app-card" [class.is-disabled]="!access?.motortwin">
            <h2>MotorTwin</h2>
            <p>Finite Element Analysis workflow for electric motor simulation.</p>
            <button class="btn btn-primary" [disabled]="!access?.motortwin" (click)="launchMotorTwin()">Open</button>
            @if (!access?.motortwin) {
            <small>This app is disabled for the selected organisation.</small>
            }
        </article>

        <article class="app-card" [class.is-disabled]="!access?.fmeda">
            <h2>FMEDA</h2>
            <p>Failure Modes, Effects and Diagnostic Analysis workspace.</p>
            <button class="btn btn-primary" [disabled]="!access?.fmeda" (click)="launchFmeda()">Open</button>
            @if (!access?.fmeda) {
            <small>This app is disabled for the selected organisation.</small>
            }
        </article>

        <article class="app-card" [class.is-disabled]="!access?.materials">
            <h2>Materials</h2>
            <p>Materials database and property lookup tool.</p>
            Coming soon ...
            @if (!access?.materials) {
            <small>This app is disabled for the selected organisation.</small>
            }
        </article>
    </div>
</div>